import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const SignupsByLocationTab: React.FC = () => (
  <LookerEmbedTab
    path="dashboards/500"
    translationKey="reports.customer.tabs.signups_by_location"
  />
)

export default SignupsByLocationTab
